// Прямые модули, а не баррел "@/partner/shared/constants": его config.ts
// читает import.meta.env (VITE_BRAND), а ts-jest кабинета (CommonJS) это не
// транспилирует (см. BillingInvoices.test.tsx).
import { MenuItems, type MenuItemProps } from "@/partner/shared/constants/menu";
import { PagePaths } from "@/partner/shared/constants/routes";
import type { EntityType } from "./types";

const flatItems = (): MenuItemProps[] =>
  MenuItems.flatMap((item) =>
    "items" in item && item.items ? item.items : [item as MenuItemProps]
  );

/** Пункт меню раздела: самый длинный `to`, с которого начинается адрес. */
export function findSectionItem(pathname: string): MenuItemProps | null {
  const matches = flatItems().filter(
    (item) => pathname === item.to || pathname.startsWith(`${item.to}/`)
  );
  return matches.sort((a, b) => b.to.length - a.to.length)[0] ?? null;
}

const ENTITY_BY_PATH: Record<string, EntityType> = {
  [PagePaths.streams]: "STREAM",
  [PagePaths.videos]: "VIDEO",
  [PagePaths.collections]: "COLLECTION",
  [PagePaths.products]: "PRODUCT",
  [PagePaths.promocodes]: "PROMOCODE",
  [PagePaths.links]: "LINK",
  [PagePaths.platformCustomCovers]: "COVER",
  [PagePaths.platformPages]: "PAGE",
};

export const entityTypeForPath = (pathname: string): EntityType | null =>
  ENTITY_BY_PATH[pathname] ?? null;
